import React, { FC, useState } from "react";
import LeftArrowSvg from "../../../assets/svg-fc/LeftArrowSvg";
import PhoneSvg from "../../../assets/svg-fc/PhoneSvg";
import DirectCallModal from "../modals/direct-call-modal/DirectCallModal";
import IsMobile from "../../../hooks/isMobile";
import WhatsAppIcon from "../../../assets/svg-fc/WhatsAppIcon";
import DeclineCorporateEventIcon from "../../../assets/svg-fc/b2b/DeclineCorporateEventIcon";
import "./innerPageMobileHeader.scss";

interface iInnerPageMobileHeaderProps {
	customerFirstLastName: string | undefined;
	eventName: string;
	eventDate: string | undefined;
	customerCID?: string;
	customerName: string;
	declineEvent?: string | undefined;
	declineEventIcon?: React.ReactNode;
	declineEventOnclick?: () => void;
	isWhatsappGroupCreated?: boolean;
	goBackOnClick: () => void;
	handleShowWhatsAppModal?: () => void;
	isCustomerPhoneNumberExist?: boolean;
}

const InnerPageMobileHeader: FC<iInnerPageMobileHeaderProps> = ({
	goBackOnClick,
	customerFirstLastName,
	eventName,
	eventDate,
	customerCID,
	customerName,
	declineEvent,
	declineEventIcon,
	declineEventOnclick,
	handleShowWhatsAppModal,
	isWhatsappGroupCreated,
	isCustomerPhoneNumberExist,
}) => {
	const isMobile = IsMobile();
	const [showCallModal, setShowCallModal] = useState(false);
	return (
		<>
			<header id="header" className="inner_page_mobile_header">
				<div className="container">
					<div className="text_hold">
						<button className="icon_hold" onClick={goBackOnClick}>
							<LeftArrowSvg />
						</button>
						<div className="header_text">
							<div className="vendor_name">
								<span>{customerFirstLastName}</span>
							</div>
							<div className="header_text_hold">
								<strong>{eventName}</strong>
								<p>
									<span>{eventDate}</span> &nbsp;| &nbsp;
									<span>{customerName}</span>
								</p>
							</div>
						</div>
					</div>
					<div className="icon_wrap">
						{handleShowWhatsAppModal && isWhatsappGroupCreated ? (
							<WhatsAppIcon onClick={handleShowWhatsAppModal} stroke="white" fill="#090909" />
						) : null}
						{customerCID && isMobile && isCustomerPhoneNumberExist ? (
							<span className="icon_hold" onClick={() => setShowCallModal(true)}>
								<PhoneSvg />
							</span>
						) : (
							<></>
						)}
						{declineEvent && declineEventOnclick && (
							<button className="icon_hold" onClick={declineEventOnclick}>
								{declineEventIcon ? declineEventIcon : <DeclineCorporateEventIcon />}
							</button>
						)}
					</div>
				</div>
			</header>
			{customerCID && (
				<DirectCallModal
					onClose={() => setShowCallModal(false)}
					open={showCallModal}
					phoneNumber={customerCID}
					customerName={customerName}
				/>
			)}
		</>
	);
};
export default InnerPageMobileHeader;
